import Vue from 'vue'
import * as Sentry from '@sentry/vue'
// services
import storage from '@/services/storage'

const INTERVAL_TIME = 10000

class OfflineWatcher {
  constructor() {
    this.tasks = storage.getValue('offlineWatcher', [])
    this.clock = null
  }

  addClock() {
    if (this.clock) return

    this.clock = setInterval(() => {
      this.runTasks()
    }, INTERVAL_TIME)
  }

  addTask(task) {
    const newTask = {
      ...task,
      id: Math.random().toString(36).substring(2),
    }

    this.tasks.push(newTask)

    storage.pushValue('offlineWatcher', newTask)

    this.addClock()
  }

  async runTasks() {
    if (this.tasks.length === 0) {
      clearInterval(this.clock)
      this.clock = null
      return
    }

    const newTasks = []

    for (let i = 0; i < this.tasks.length; i++) {
      const task = this.tasks[i]

      const resource = Vue.resource('', {}, {
        [task.id]: task.action,
      })

      try {
        // eslint-disable-next-line no-await-in-loop
        await resource[task.id](task.params, task.payload)
      } catch (e) {
        Sentry.captureException(e)
        newTasks.push(task)
      }
    }

    this.tasks = newTasks
    storage.setValue('offlineWatcher', newTasks)

    if (newTasks.length !== 0) {
      this.addClock()
    }
  }
}

export default new OfflineWatcher()
